import { render, staticRenderFns } from "./ApplicationMedicalSpecialties.vue?vue&type=template&id=2abd77ff&"
import script from "./ApplicationMedicalSpecialties.vue?vue&type=script&lang=ts&"
export * from "./ApplicationMedicalSpecialties.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports